/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { colors } from "../../components/colors";
import { effects } from "../../components/effects";
import { StyledText } from "../../assets/typography/typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "antd";
import { IconButton } from "../../components/IconButton";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { UseFieldArrayRemove } from "react-hook-form";

const iconButtonStyle = css`
  color: ${colors.textSecondary};
  &:hover {
    color: ${colors.textPrimary};
  }
`;

const containerStyle = css`
  display: flex;
  flex-direction: row;
  width: 100%;
  border-radius: 4px;
  cursor: grab;
  padding: 8px;
  justify-content: space-between;
  &:hover {
    background-color: ${colors.whiteHover};
  }
  align-items: center;
  box-shadow: ${effects.buttonPrimary};
`;

const sortKeyStyle = css`
  display: flex;
  border: none;
  width: 24px;
  height: 24px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  background-color: ${colors.ctaInactive};
  border-radius: 9999px;
`;

const innerStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

type Props = {
  provider: any;
  remove: UseFieldArrayRemove;
};

export const DeliveryProviderRow = ({ provider, remove }: Props) => {
  return (
    <div css={containerStyle} key={provider.id} data-id={provider.fieldIndex}>
      <div css={innerStyle}>
        <StyledText
          className="bodySubtextRegular mb-0"
          color={colors.textPrimary}
        >
          <FontAwesomeIcon icon={solid("grip")} />
        </StyledText>
        <Tooltip
          title="Priority"
          arrow={false}
          placement="right"
          overlayInnerStyle={{
            fontFamily: "Inter",
            fontSize: "14px",
          }}
        >
          <div css={sortKeyStyle}>
            <StyledText
              className="bodySubtextSemibold mb-0"
              color={colors.textPrimary}
            >
              {provider.priority}
            </StyledText>
          </div>
        </Tooltip>
        <div> {provider.name}</div>
      </div>
      <IconButton
        css={iconButtonStyle}
        onClick={() => remove(provider.fieldIndex)}
        icon={<FontAwesomeIcon fontSize="12px" icon={solid("x")} />}
      />
    </div>
  );
};
